import React from 'react';
import { PATH } from 'constants/path';
import Home from 'pages/Home';
import Template from 'pages/TemplatePage';
import SignUpPage from 'pages/SignUpPage';
import ProviderOnboardingPage from 'pages/ProviderOnboardingPage';
import InvitedProviderActivateAccountPage from 'pages/InvitedProviderOnboarding/ActivateAccount';
import InvitedProviderCreateProfilePage from 'pages/InvitedProviderOnboarding/CreateProfile';
import InvitedProviderSetupServicesPage from 'pages/InvitedProviderOnboarding/SetupServices';
import InvitedProviderAvailabilityPage from 'pages/InvitedProviderOnboarding/Availability';
import InvitedProviderMarketingProfilePage from 'pages/InvitedProviderOnboarding/MarketingProfile';
import InvitedProviderReviewPage from 'pages/InvitedProviderOnboarding/Review';
import InvitedProviderGoLivePage from 'pages/InvitedProviderOnboarding/GoLive';
import InvitedProviderAdvancedSettingsPage from 'pages/InvitedProviderOnboarding/AdvancedSettings';
import InvitedProviderAdvancedSettingsSuccessPage from 'pages/InvitedProviderOnboarding/AdvancedSettingsSuccess';
import MobileNotSupportPage from 'pages/MobileNotSupportPage';
import SavedDraftPage from 'pages/SavedDraftPage';
import RedirectPage from 'pages/RedirectPage';
import QuestionsPage from 'pages/QuestionsPage';

import AppointmentGooglePage from 'pages/dashboard/AppointmentManagePage/indexGoogle';
// import CreateUniProfilePage from 'pages/CreateUniProfilePage';
import ChannelAppointmentSuccess from 'pages/ChannelAppointmentSuccess';
import LoginPage from 'pages/LoginPage';
import ChannelDetailListSuccessPage from 'pages/ChannelDetailListSuccessPage';
import UniProfileEntry from 'pages/UniProfileEntry';

/* dashboard */
import AppointmentPage from 'pages/dashboard/AppointmentPage';
import AppointmentManagePage from 'pages/dashboard/AppointmentManagePage';
import AppointmentSettingPage from 'pages/dashboard/AppointmentSettingPage';
import RecommendChannelsPage from 'pages/dashboard/RecommendChannels';
import ChannelDetailPage from 'pages/dashboard/ChannelDetail';
import ChannelLandingPage from 'pages/dashboard/ChannelLandingPage';
import ChannelMainPage from 'pages/dashboard/ChannelMainPage';
import ChannelSurveyPage from 'pages/dashboard/ChannelSurveyPage';
import ProspectsPage from 'pages/dashboard/ProspectsPage';
import PracticeFrontPage from 'pages/dashboard/PracticeFrontPage';
import CustomizePracticeFrontPage from 'pages/dashboard/CustomizePracticeFrontPage';
import ProspectsManagePage from 'pages/dashboard/ProspectsManagePage';
import ProspectsDetailPage from 'pages/dashboard/ProspectsDetailPage';
import CalendarPage from 'pages/dashboard/CalendarPage';
import CalendarSettingPage from 'pages/dashboard/CalendarSettingPage';
import MarketingPage from 'pages/dashboard/Marketing';
import InsuranceBillingPage from 'pages/dashboard/InsuranceBillingPage';
import MarketingSettingPage from 'pages/dashboard/MarketingSettingPage';
import ProfilePage from 'pages/ProfilePage';
/* end dashboard */

/* operation */
import OperationLayout from 'pages/OperationLayout';
import OperationInnerLayout from 'pages/OperationLayout/inner';
import OpProviderPage from 'pages/operation/ProviderPage';
import ProviderOnboardDetailPage from 'pages/operation/ProviderOnboardDetailPage';
import ListToChannelDetailPage from 'pages/operation/ListToChannelDetailPage';
import ChannelItemAddAndEditPage from 'pages/operation/ChannelItemAddAndEditPage';
import OpChannelPage from 'pages/operation/ChannelPage';
// import ServicesTemplatePage from 'pages/operation/ServicesTemplatePage';
import ServicesTemplatePage from 'pages/operation/ServiceTemplateManagement';
import HomeConfigPage from 'pages/operation/HomeConfigPage';
import HelloKlarityPage from 'pages/operation/HelloKlarityPage';
import KiwiHealthPage from 'pages/operation/KiwiHealthPage';
import ChannelWithdrawDetailPage from 'pages/operation/ChannelWithdrawDetailPage';
import OperationMessagesPage from 'pages/operation/OpsMessagePage';
/* end operation */

/* preview */
import ZocDocPage from 'pages/preview/ZocDocPage';
import GooglePage from 'pages/preview/GooglePage';
import YelpPage from 'pages/preview/YelpPage';

import Layout from 'pages/Layout';

import { RouteObject } from 'react-router-dom';
import PracticeFrontVotePage from 'pages/dashboard/PracticeFrontVotePage';
import PracticefrontCreateSuccessPage from 'pages/dashboard/PracticeFrontCreateSuccessPage';
import OpsMember from 'pages/AccessManagement/OpsMember';
import DevWhitelist from 'pages/AccessManagement/DevWhitelist';
import Roles from 'pages/AccessManagement/Roles';
import { PermissionModuleKeys } from 'constants/access';
import AccessDeniedPage from 'pages/AccessManagement/AccessDenied';
import { isSuperAdmin } from 'utils/access';
import { getUserToken } from 'utils/localstore';
import SomethingWentWrongPage from 'pages/SomethingWentWrongPage';
import UnderMaintenancePage from 'pages/UnderMaintenancePage';
import NotFoundPage from 'pages/NotFoundPage';
import ProviderLoginPage from 'pages/ProviderLoginPage';
import ProviderHomePage from 'pages/dashboard/ProviderHomePage';
import ResetPasswordPage from 'pages/ResetPasswordPage';
import VerificationFailPage from 'pages/VerificationFailPage';
import AiChatPage from 'pages/AiChatPage';
import InitUniProfilePage from 'pages/InitUniProfilePage';
import PaySuccessPage from 'pages/PaySuccessPage';
import ReputationManagementPage from 'pages/dashboard/ReputationManagementPage';
import { getElementWithTargetRole, isPrereleaseEnv, isProductionEnv } from 'utils/common';
import ReputationConfigPage from 'pages/dashboard/ReputationConfigPage';
import ReputationDashboardPage from 'pages/dashboard/ReputationDashboradPage';
import ReputationConfigSuccessfullyPage from 'pages/dashboard/ReputationConfigSuccessfully';
import UniprofileResume from 'pages/UniprofileResume';

import AiConfigPage from 'pages/operation/AiConfigPage';
import Configurations from 'pages/operation/Configurations';
import HelloKlarityProviders from 'pages/operation/HelloKlarityProviders';
import CustomizeHelloKlarityPPP from 'pages/operation/CustomizeHelloKlarityPPP';
import CustomizeHelloKlarityPPA from 'pages/operation/CustomizeHelloKlarityPPP/ppa';
import HelloKlarityMappingGoLiveSuccess from 'pages/operation/HelloKlarityMappingGoLiveSuccess';
import HelloKlarityMappingPauseSuccess from 'pages/operation/HelloKlarityMappingPauseSuccess';
import HelloKlarityPageManagement from 'pages/operation/HelloKlarityPageManagement';
import HelloKlarityReviews from 'pages/operation/HelloKlarityReviews';
import HelloKlarityAssessment from 'pages/operation/HelloKlarityAssessment';
import TextVisitEmbeddableWorkflows from 'pages/operation/TextVisitEmbeddableWorkflows';
import IntakeWorkflows from 'pages/operation/IntakeWorkflows';
import TextVisitEmbeddableWorkflowsDetail from 'pages/operation/TextVisitEmbeddableWorkflows/detail';
import IntakeWorkflowsDetail from 'pages/operation/IntakeWorkflows/detail';
import VisualFlowBuilderPage from 'pages/operation/TextVisitEmbeddableWorkflows/components/DecisionTree/VisualFlowBuilderPage';
import TextVisitCases from 'pages/operation/TextVisitCases';
import TextVisitProvider from 'pages/operation/TextVisitProvider';
import HelloKlarityProviderResource from 'pages/operation/HelloKlarityProviderResourcePage';
import KlarityReviewsDetailPage from 'pages/operation/HelloKlarityReviews/detail';
import KlarityAssessmentDetailPage from 'pages/operation/HelloKlarityAssessment/detail';
import HelloKlarityPageDetail from 'pages/operation/HelloKlarityPageManagement/detail';
// import HelloKlarityQA from 'pages/operation/HelloKlarityQA';
import ChannelNotFound from 'pages/dashboard/ChannelNotFound';
import SalesProviderExp from 'pages/SalesProviderExp';
import ContractLink from 'pages/operation/ContractLinkPage';
import EHROnboardingPage from 'pages/dashboard/EHROnboardingPage';
// import AppointmentTime from 'components/AppointmentTime';
import EHRCart from 'pages/dashboard/EHRCart';
import ProviderSearchPage from 'pages/operation/ProviderSearchPage';
import EhrAddOnLinkPage from 'pages/operation/EhrAddOnLinkPage';
import EhrProviderHomePage from 'pages/dashboard/EhrProviderHomePage';
import EhrProviderAddOnPage from 'pages/dashboard/EhrProviderAddOnPage';
import EHRAddonDetail from 'pages/operation/EHRAddonDetail';
import KlarityPlanProcess from 'pages/dashboard/KlarityProcessPages/KlarityPlanProcess';
import KiwiKnowledge from 'pages/dashboard/KlarityProcessPages/KiwiKnowledgePage';
import KlarityPlanSubscribePage from 'pages/dashboard/KlarityProcessPages/KlarityPlanSubscribePage';
import KlarityAgreementPage from 'pages/dashboard/KlarityProcessPages/KlarityAgreementPage';
import PPAKlarityReviewsPage from 'pages/dashboard/PPAKlarityReviewsPage';
import AvaSettingPage from 'pages/dashboard/AvaSettingPage';
import KlarityProgramDetailPage from 'pages/operation/KlarityProgramDetailPage';
import HelpCenter from 'pages/dashboard/HelpCenter';
import StripeCheckoutIdPage from 'pages/TEST_GetStripeCheckoutId';
import ServiceSettingPage from 'pages/dashboard/ServiceSettingPage';
import ServiceSettingSuccessPage from 'pages/dashboard/ServiceSettingSuccessPage';
import MedicationSettingsPage from 'pages/MedicationSettingsPage';
import MedicationSettingsSuccessPage from 'pages/MedicationSettingSuccess';

// testing
import ReviewTest from 'pages/testing/Review';
import ProviderTest from 'pages/testing/Provider';
import MobileWelcomePage from 'pages/MobileWelcomePage';
import { FunctionProvider } from 'utils/functionContext';
import PaymentSetup from 'pages/PaymentSetup';
import PaymentSetupSuccess from 'pages/PaymentSetupSuccess';
import InboxPage from 'pages/dashboard/InboxPage';
import ClosedFunnel from 'pages/operation/ClosedFunnel';
import ClosedFunnelDetailPage from 'pages/operation/ClosedFunnelDetail';
import MedicationListPageManagement from 'pages/operation/MedicationListPageManagement';

import ChannelPaymentPage from 'pages/ChannelPaymentPage';
import ChannelPaymentSuccessPage from 'pages/ChannelPaymentSuccessPage';
import ThirdPartyPage from 'pages/operation/ThirdPartyPage';
import ProListingSetup from 'pages/ProListingSetup';
import ProListingSetupSuccess from 'pages/ProListingSetupSuccess';

import PPALeadFormPage from 'pages/PPALeadFormPage';
import PPACredentialingLandingPage from 'pages/PPACredentialingLandingPage';
import PPACredentialingStartPage from 'pages/PPACredentialingStartPage';
import PPACredentialingSubmittedPage from 'pages/PPACredentialingSubmittedPage';
import InsuranceBillingLandingPage from 'pages/InsuranceBillingLandingPage';
import InsuranceBillingOnboarding from 'pages/InsuranceBillingOnboarding';
import InsuranceBillingSubmittedPage from 'pages/InsuranceBillingSubmittedPage';
import PPAReviewPage from 'pages/PPAOnboardingReviewPage';
import PPAOnboardingFinishPage from 'pages/PPAOnboardingFinishPage';
import PPALoginPage from 'pages/PPALoginPage';
import PPAOnboardingStepsPage from 'pages/PPAOnboardingSteps';
import PPAOnboardingAdvanceSettingPage from 'pages/PPAAdvanceSettingPage';
import PPAOnboardingAdvanceSettingSuccessPage from 'pages/PPAAdvanceSettingSuccessPage';
import PPARedirectPage from 'pages/PPARedirectPage';
import PPAResetPasswordPage from 'pages/PPAResetPasswordPage';
import SwitchAccountRedirectPage from 'pages/SwitchAccountRedirectPage';
import SwitchAccountNoticePage from 'pages/SwitchAccountNoticePage';
import PPAProviderDetailPage from 'pages/operation/PPAProviderDetailPage';
import GroupPracticeDetailPage from 'pages/operation/GroupPracticeDetailPage';
import GPAnalyticsPage from 'pages/operation/GroupPractice/Analytics';
import GPApplicationsPage from 'pages/operation/GroupPractice/Applications';
import GPAuditLogPage from 'pages/operation/GroupPractice/AuditLog';
import GPOverviewPage from 'pages/operation/GroupPractice/Overview';
import GPReassignLogPage from 'pages/operation/GroupPractice/ReassignLog';
import GPStaffDetailPage from 'pages/operation/GroupPractice/StaffDetail';
import PPAServiceTemplateSetting from 'pages/ServiceTemplateSetting';
import ClearsessionPage from 'pages/ClearsessionPage';
import TextVisitPage from 'pages/dashboard/TextVisitPage';
import PrescriptionsPage from 'pages/dashboard/PrescriptionsPage';
import TextVisitProviderCasePage from 'pages/operation/TextVisitProviderCase';
import FinancialsPage from 'pages/dashboard/FinancialsPage';
import CredentialingPage from 'pages/dashboard/CredentialingPage';
import VideoPreparePage from 'pages/VideoPreparePage';
import MeetingPage from 'pages/MeetingPage';
import MeetingEndPage from 'pages/MeetingEndPage';
import EFaxPage from 'pages/dashboard/EFaxPage';
import ProviderSelectOrgPage from 'pages/dashboard/ProviderSelectOrgPage';
import SelectPracticePage from 'pages/SelectPracticePage';
import PracticeOverviewPage from 'pages/dashboard/PracticeOverviewPage';
import ReviewProviderProfilePage from 'pages/ReviewProviderProfilePage';
import AddGroupProviderPage from 'pages/AddGroupProviderPage';
import GroupCredentialingPage from 'pages/GroupCredentialingPage';
import AddCredentialingProvidersPage from 'pages/AddCredentialingProvidersPage';
import SelectWebsiteProvidersPage from 'pages/SelectWebsiteProvidersPage';

const ROUTERS = (access: Record<PermissionModuleKeys, boolean> | null, roles: string[]): RouteObject[] => {
    return [
        {
            path: PATH.TEMPLATE,
            element: <Template />,
        },
        {
            path: PATH.SIGNUP,
            element: <SignUpPage />,
        },
        {
            path: PATH.ONBOARDING,
            element: <ProviderOnboardingPage />,
        },
        {
            path: PATH.MOBILE_NOT_SUPPORT,
            element: <MobileNotSupportPage />,
        },
        {
            path: PATH.MOBILE_WELCOME,
            element: <MobileWelcomePage />,
        },
        {
            path: PATH.SAVED_DRAFT,
            element: <SavedDraftPage />,
        },
        {
            path: PATH.REDIRECT,
            element: <RedirectPage />,
        },
        {
            path: PATH.QUESTIONS,
            element: <QuestionsPage />,
        },
        {
            path: PATH.CHANNEL_SURVEY,
            element: <ChannelSurveyPage />,
        },
        {
            path: PATH.CHANNEL_PAYMENT,
            element: <ChannelPaymentPage />,
        },
        {
            path: PATH.CHANNEL_PAYMENT_SUCCESS,
            element: <ChannelPaymentSuccessPage />,
        },
        {
            path: PATH.CUSTOMIZE_PRACTICE_FRONT,
            element: <CustomizePracticeFrontPage />,
        },
        {
            path: PATH.PRACTICE_FRONT_VOTE_PAGE,
            element: <PracticeFrontVotePage />,
        },
        {
            path: PATH.UNIPROFILE_RESUME,
            element: <UniprofileResume />,
        },
        {
            path: PATH.EHR_ONBOARDING,
            element: <EHROnboardingPage />,
        },
        {
            path: PATH.PPA_LEAD_FORM,
            element: <PPALeadFormPage />,
        },
        {
            path: PATH.CREDENTIALING_START,
            element: <PPACredentialingStartPage />,
        },
        {
            path: PATH.CREDENTIALING_SUBMITTED,
            element: <PPACredentialingSubmittedPage />,
        },
        {
            path: PATH.INSURANCE_BILLING_ONBOARDING,
            element: <InsuranceBillingOnboarding />,
        },
        {
            path: PATH.INSURANCE_BILLING_ONBOARDING_SUBMITTED,
            element: <InsuranceBillingSubmittedPage />,
        },
        {
            path: PATH.PROVIDER_SELECT_ORG,
            element: <ProviderSelectOrgPage />,
        },
        {
            path: PATH.SELECT_PRACTICE,
            element: <SelectPracticePage />,
        },
        {
            path: PATH.PPA_ONBOARDING_REVIEW,
            element: <PPAReviewPage />,
        },
        {
            path: PATH.PPA_ONBOARDING_FINISH,
            element: <PPAOnboardingFinishPage />,
        },
        {
            path: PATH.CLEAR_SESSION,
            element: <ClearsessionPage />,
        },
        // {
        //     path: PATH.PPA_SIGNUP,
        //     element: <PPASignUpPage />,
        // },
        {
            path: PATH.PPA_LOGIN,
            element: <PPALoginPage />,
        },
        {
            path: PATH.PPA_ONBOARDING_STEPS,
            element: <PPAOnboardingStepsPage />,
        },
        {
            path: PATH.INVITED_PROVIDER_ONBOARDING_ACTIVATE,
            element: <InvitedProviderActivateAccountPage />,
        },
        {
            path: PATH.INVITED_PROVIDER_ONBOARDING_CREATE_PROFILE,
            element: <InvitedProviderCreateProfilePage />,
        },
        {
            path: PATH.INVITED_PROVIDER_ONBOARDING_SERVICES,
            element: <InvitedProviderSetupServicesPage />,
        },
        {
            path: PATH.INVITED_PROVIDER_ONBOARDING_AVAILABILITY,
            element: <InvitedProviderAvailabilityPage />,
        },
        {
            path: PATH.INVITED_PROVIDER_ONBOARDING_MARKETING_PROFILE,
            element: <InvitedProviderMarketingProfilePage />,
        },
        {
            path: PATH.INVITED_PROVIDER_ONBOARDING_REVIEW,
            element: <InvitedProviderReviewPage />,
        },
        {
            path: PATH.INVITED_PROVIDER_GO_LIVE,
            element: <InvitedProviderGoLivePage />,
        },
        {
            path: PATH.INVITED_PROVIDER_ADVANCED_SETTINGS,
            element: <InvitedProviderAdvancedSettingsPage />,
        },
        {
            path: PATH.INVITED_PROVIDER_ADVANCED_SETTINGS_SUCCESS,
            element: <InvitedProviderAdvancedSettingsSuccessPage />,
        },
        {
            path: PATH.PPA_ONBOARDING_ADVANCE_SETTING,
            element: <PPAOnboardingAdvanceSettingPage />,
        },
        {
            path: PATH.CREDENTIALING_LANDING,
            element: <PPACredentialingLandingPage />,
        },
        {
            path: PATH.INSURANCE_BILLING_LANDING,
            element: <InsuranceBillingLandingPage />,
        },
        {
            path: PATH.PPA_ONBOARDING_ADVANCE_SETTING_SUCCESS,
            element: <PPAOnboardingAdvanceSettingSuccessPage />,
        },
        {
            path: PATH.PPA_REDIRECT,
            element: <PPARedirectPage />,
        },
        {
            path: PATH.PPA_RESET_PASSWORD,
            element: <PPAResetPasswordPage />,
        },
        {
            path: PATH.SWITCH_ACCOUNT_REDIRECT,
            element: <SwitchAccountRedirectPage />,
        },
        {
            path: PATH.SWITCH_ACCOUNT_NOTICE,
            element: <SwitchAccountNoticePage />,
        },
        {
            path: PATH.MEETING_END,
            element: <MeetingEndPage />,
        },
        {
            path: PATH.DASHBOARD,
            element: <Layout />,
            children: [
                {
                    index: true,
                    element: <ProviderHomePage />,
                },
                {
                    path: PATH.PROVIDER_HOME,
                    element: <ProviderHomePage />,
                },
                {
                    path: PATH.EHR_HOME_PROVIDER,
                    element: <EhrProviderHomePage />,
                },
                {
                    path: PATH.EHR_ADD_ON_PROVIDER,
                    element: <EhrProviderAddOnPage />,
                },
                {
                    path: PATH.APPOINTMENT,
                    element: <AppointmentPage />,
                },
                {
                    path: PATH.APPOINTMENT_MANAGEMENT,
                    element: <AppointmentManagePage />,
                },
                {
                    path: PATH.APPOINTMENT_SETTING,
                    element: <AppointmentSettingPage />,
                },
                {
                    path: PATH.APPOINTMENT_GOOGLE,
                    element: <AppointmentGooglePage />,
                },
                {
                    path: PATH.CHANNEL_DETAIL,
                    element: <ChannelDetailPage />,
                },
                {
                    path: PATH.CHANNEL_LANDING,
                    element: <ChannelLandingPage />,
                },
                {
                    path: PATH.CHANNEL,
                    element: <ChannelMainPage />,
                },
                {
                    path: PATH.PROSPECTS,
                    element: <ProspectsPage />,
                },
                {
                    path: PATH.CLIENTS,
                    element: <ProspectsManagePage />,
                },
                {
                    path: PATH.PRACTICE_FRONT,
                    element: <PracticeFrontPage />,
                },
                {
                    path: PATH.PROSPECTS_MANAGE,
                    element: <ProspectsManagePage />,
                },
                {
                    path: `${PATH.PROSPECTS_DETAIL}/:id`,
                    element: <ProspectsDetailPage />,
                },
                {
                    path: `${PATH.GP_PROSPECTS_DETAIL}/:id`,
                    element: <ProspectsDetailPage />,
                },
                {
                    path: PATH.REPUTATION_MANAGEMENT,
                    element: <ReputationManagementPage />,
                },
                {
                    path: PATH.KLARITY_REVIEWS,
                    element: <PPAKlarityReviewsPage />,
                },
                {
                    path: PATH.REPUTATION_DASHBORAD,
                    element: <ReputationDashboardPage />,
                },
                {
                    path: PATH.CHANNEL_NOT_FOUND,
                    element: <ChannelNotFound />,
                },
                {
                    path: PATH.EHR_CART,
                    element: <EHRCart />,
                },
                {
                    path: PATH.AVA_SETTING,
                    element: <AvaSettingPage />,
                },
                {
                    path: PATH.HELP_CENTER,
                    element: <HelpCenter />,
                },
                {
                    path: PATH.CALENDAR,
                    element: <CalendarPage />,
                },
                {
                    path: PATH.CALENDAR_SETTING,
                    element: <CalendarSettingPage />,
                },
                {
                    path: PATH.INBOX,
                    element: <InboxPage />,
                },
                {
                    path: PATH.MARKETING,
                    element: <MarketingPage />,
                },
                {
                    path: PATH.INSURANCE_BILLING,
                    element: <InsuranceBillingPage />,
                },
                {
                    path: PATH.MARKETING_SETTING,
                    element: <MarketingSettingPage />,
                },
                {
                    path: PATH.PROFILE,
                    element: <ProfilePage />,
                },
                {
                    path: PATH.TEXT_VISIT,
                    element: <TextVisitPage />,
                },
                {
                    path: PATH.PRESCRIPTIONS,
                    element: <PrescriptionsPage />,
                },
                {
                    path: PATH.FINANCIALS,
                    element: <FinancialsPage />,
                },
                {
                    path: PATH.CREDENTIALING,
                    element: <CredentialingPage />,
                },
                {
                    path: PATH.EFAX,
                    element: <EFaxPage />,
                },
                {
                    path: PATH.PRACTICE_OVERVIEW,
                    element: <PracticeOverviewPage />,
                },
            ],
        },
        {
            path: PATH.REVIEW_PROVIDER_PROFILE,
            element: <ReviewProviderProfilePage />,
        },
        {
            path: PATH.ADD_GROUP_PROVIDER,
            element: <AddGroupProviderPage />,
        },
        {
            path: PATH.GROUP_CREDENTIALING,
            element: <GroupCredentialingPage />,
        },
        {
            path: PATH.ADD_CREDENTIALING_PROVIDER,
            element: <AddCredentialingProvidersPage />,
        },
        {
            path: PATH.SELECT_WEBSITE_PROVIDERS,
            element: <SelectWebsiteProvidersPage />,
        },
        {
            path: PATH.OPERATION,
            element: <OperationLayout />,
            children: [
                {
                    index: true,
                    element: <OpProviderPage />,
                },
                {
                    path: PATH.PROVIDER_SEARCH,
                    element: <ProviderSearchPage />,
                },
                {
                    path: PATH.PROVIDER,
                    element: <OpProviderPage />,
                },
                {
                    path: PATH.CHANNEL,
                    element: <OpChannelPage />,
                },
                {
                    path: `${PATH.PROVIDER_ONBOARD_DETAIL}/:id`,
                    element: <ProviderOnboardDetailPage />,
                },
                {
                    path: `${PATH.LIST_TO_CHANNEL_DETAIL}/:id/:pid`,
                    element: <ListToChannelDetailPage />,
                },
                {
                    path: `${PATH.CHANNEL_WITHDRRAW_DETAIL}/:id/:channelId/:providerId`,
                    element: <ChannelWithdrawDetailPage />,
                },
                {
                    //this id means provider id
                    path: `${PATH.UNIPROFILE_DETAIL}/:id/:pid`,
                    element: <ListToChannelDetailPage />,
                },
                {
                    path: `${PATH.CHANNEL_UPDATE}/:id`,
                    element: <ChannelItemAddAndEditPage />,
                },
                {
                    path: `${PATH.CHANNEL_UPDATE}`,
                    element: <ChannelItemAddAndEditPage />,
                },
                {
                    path: `${PATH.SERVICES_TEMPLATE}`,
                    element: <ServicesTemplatePage />,
                    // element: getElementWithTargetRole({
                    //     access: access || undefined,
                    //     element: <ServicesTemplatePage />,
                    //     targetRoles: [PermissionModuleKeys.SERVICE_TEMPLATE],
                    // }),
                },
                {
                    path: PATH.OPS_MEMBER,
                    element: <OpsMember />,
                },
                {
                    path: PATH.DEV_WIHTELIST,
                    element: <DevWhitelist />,
                },
                {
                    path: PATH.HOME_CONFIG,
                    element: getElementWithTargetRole({
                        access: access || undefined,
                        element: <HomeConfigPage />,
                        targetRoles: [PermissionModuleKeys.HOME_CONFIG],
                    }),
                },
                {
                    path: PATH.AI_CONFIG,
                    element: <AiConfigPage />,
                },
                {
                    path: PATH.CONFIGURATIONS,
                    element: getElementWithTargetRole({
                        access: access || undefined,
                        element: <Configurations />,
                        targetRoles: [PermissionModuleKeys.CONFIGURATIONS],
                    }),
                },
                {
                    path: PATH.ROLES,
                    element: isSuperAdmin(roles) ? <Roles /> : <AccessDeniedPage />,
                },
                {
                    path: PATH.HELLO_KLARITY,
                    element: <HelloKlarityPage />,
                },
                {
                    path: PATH.KIWI_HEALTH,
                    element: getElementWithTargetRole({
                        access: access || undefined,
                        element: <KiwiHealthPage />,
                        targetRoles: [PermissionModuleKeys.KIWI_HEALTH_PAGE, PermissionModuleKeys.KIWI_HEALTH_PROVIDER],
                    }),
                },
                {
                    path: PATH.HELLO_KLARITY_PROVIDERS,
                    element: <HelloKlarityProviders />,
                },
                {
                    path: PATH.HELLO_KLARITY_PAGE_MANAGEMENT,
                    element: <HelloKlarityPageManagement />,
                },
                {
                    path: PATH.HELLO_KLARITY_PROVIDER_RESOURCES,
                    element: <HelloKlarityProviderResource />,
                },
                {
                    path: PATH.KLARITY_REVIEWS,
                    element: <HelloKlarityReviews />,
                },
                {
                    path: `${PATH.KLARITY_REVIEWS_DETAIL}/:providerId/:providerSource`,
                    element: <KlarityReviewsDetailPage />,
                },
                {
                    path: PATH.KLARITY_ASSESSMENT,
                    element: <HelloKlarityAssessment />,
                },
                {
                    path: PATH.TEXT_VISIT_EMBEDDABLE_WORKFLOWS,
                    element: <TextVisitEmbeddableWorkflows />,
                },
                {
                    path: PATH.INTAKE_WORKFLOWS,
                    element: <IntakeWorkflows />,
                },
                {
                    path: PATH.TEXT_VISIT_CASE,
                    element: <TextVisitCases />,
                },
                {
                    path: PATH.TEXT_VISIT_PROVIDER,
                    element: <TextVisitProvider />,
                },
                {
                    path: PATH.CONTRACT_LINK_PAGE,
                    element: <ContractLink />,
                },
                {
                    path: PATH.ACCESS_DENIED,
                    element: <AccessDeniedPage />,
                },
                {
                    path: PATH.EHR_ADD_ON_OPS,
                    element: <EhrAddOnLinkPage />,
                },
                {
                    path: `${PATH.EHR_ADD_ON_DETAIL}/:providerId`,
                    element: <EHRAddonDetail />,
                },
                {
                    path: `${PATH.KLARITY_SELECT_PROGRAMS_DETAIL}/:id`,
                    element: <KlarityProgramDetailPage />,
                },
                {
                    path: PATH.CLOSED_FUNNEL,
                    element: <ClosedFunnel />,
                },
                {
                    path: PATH.OPS_THIRD_PARTY_PAGE,
                    element: <ThirdPartyPage />,
                },
                {
                    path: PATH.MESSAGES,
                    element: <OperationMessagesPage />,
                },
                {
                    path: PATH.GP_ANALYTICS,
                    element: <GPAnalyticsPage />,
                },
                {
                    path: PATH.GP_APPLICATIONS,
                    element: <GPApplicationsPage />,
                },
                {
                    path: PATH.GP_AUDIT_LOG,
                    element: <GPAuditLogPage />,
                },
                {
                    path: PATH.GP_OVERVIEW,
                    element: <GPOverviewPage />,
                },
                {
                    path: PATH.GP_REASSIGN_LOG,
                    element: <GPReassignLogPage />,
                },
                {
                    path: `${PATH.GP_STAFF_DETAIL}/:id`,
                    element: <GPStaffDetailPage />,
                },
            ],
        },
        {
            path: PATH.OPERATION,
            element: <OperationInnerLayout />,
            children: [
                {
                    path: `${PATH.HELLO_KLARITY_PAGE_DETAIL}/:type/:id`,
                    element: <HelloKlarityPageDetail />,
                },
                {
                    path: PATH.MEDICATION_LIST_PAGE_MANAGEMENT,
                    element: <MedicationListPageManagement />,
                },
            ],
        },
        {
            path: PATH.OPERATION,
            element: <OperationInnerLayout />,
            children: [
                {
                    path: `${PATH.KLARITY_ASSESSMENT_DETAIL}`,
                    element: <KlarityAssessmentDetailPage />,
                },
                {
                    path: `${PATH.EMBEDDABLE_WORKFLOWS_DETAIL}`,
                    element: <TextVisitEmbeddableWorkflowsDetail />,
                },
                {
                    path: `${PATH.INTAKE_WORKFLOWS_DETAIL}`,
                    element: <IntakeWorkflowsDetail />,
                },
                {
                    path: `${PATH.VISUAL_FLOW_BUILDER}`,
                    element: <VisualFlowBuilderPage />,
                },
                {
                    path: `${PATH.CLOSED_FUNNEL_DETAIL}/:id`,
                    element: <ClosedFunnelDetailPage />,
                },
                {
                    path: `${PATH.PPA_PROVIDER_DETAIL}/:id/:pid`,
                    element: <PPAProviderDetailPage />,
                },
                {
                    path: `${PATH.GROUP_PRACTICE_DETAIL}/:gpId`,
                    element: <GroupPracticeDetailPage />,
                },
                {
                    path: `${PATH.TEXT_VISIT_PROVIDER_CASE}`,
                    element: <TextVisitProviderCasePage />,
                },
            ],
        },
        {
            path: PATH.PREVIEW,
            element: <Layout />,
            children: [
                {
                    path: `${PATH.ZOCDOC}/:id`,
                    element: <ZocDocPage />,
                },
                {
                    path: `${PATH.GOOGLE}/:id`,
                    element: <GooglePage />,
                },
                {
                    path: `${PATH.YELP}/:id`,
                    element: <YelpPage />,
                },
            ],
        },
        {
            path: PATH.CREATE_UNI_PROFILE,
            element: (
                <FunctionProvider>
                    <UniProfileEntry />
                </FunctionProvider>
            ),
        },
        {
            path: PATH.SERVICE_SETTING_SUCCESS,
            element: <ServiceSettingSuccessPage />,
        },
        {
            path: PATH.LOGIN,
            element: <LoginPage />,
        },
        {
            path: PATH.HOME,
            element: <Home />,
        },
        {
            path: PATH.RECOMMEND_CHANNELS,
            element: <RecommendChannelsPage />,
        },
        {
            path: PATH.CHANNEL_APPOINTMENT_SUCCESS,
            element: <ChannelAppointmentSuccess />,
        },
        {
            path: PATH.PRACTICE_FRONT_CREATE_SUCCESS,
            element: <PracticefrontCreateSuccessPage />,
        },
        {
            path: PATH.CHANNEL_DETAIL_LIST_SUCCESS,
            element: <ChannelDetailListSuccessPage />,
        },
        {
            path: PATH.DEV_GET_TOKEN,
            element: (
                <div
                    style={{
                        fontSize: 12,
                        padding: 48,
                        wordWrap: 'break-word',
                    }}
                >
                    {getUserToken()}
                </div>
            ),
        },
        {
            path: PATH.AI_CHAT,
            element: <AiChatPage />,
        },
        {
            path: PATH.SOMETHING_WENT_WRONG,
            element: <SomethingWentWrongPage />,
        },
        {
            path: PATH.UNDER_MAINTENANCE,
            element: <UnderMaintenancePage />,
        },
        {
            path: PATH.PROVIDER_LOGIN,
            element: <ProviderLoginPage />,
        },
        {
            path: PATH.RESET_PASSWORD,
            element: <ResetPasswordPage />,
        },
        {
            path: PATH.VERIFICATION_FAIL,
            element: <VerificationFailPage />,
        },
        {
            path: PATH.INIT_UNIPROFILE,
            element: <InitUniProfilePage />,
        },
        {
            path: PATH.PAY_SUCCESS,
            element: <PaySuccessPage />,
        },
        {
            path: PATH.REPUTATION_CONFIG_PAGE,
            element: <ReputationConfigPage />,
        },
        {
            path: PATH.REPUTATION_CONFIG_SUCCESS,
            element: <ReputationConfigSuccessfullyPage />,
        },
        {
            path: PATH.CUSTOMIZE_PROVIDER_PROFILE_PAGE,
            element: <CustomizeHelloKlarityPPP />,
        },
        {
            path: PATH.CUSTOMIZE_PROVIDER_PROFILE_PAGE_PPA,
            element: <CustomizeHelloKlarityPPA />,
        },
        {
            path: PATH.HELLO_KLARITY_MAPPING_GOLIVE_SUCCESS,
            element: <HelloKlarityMappingGoLiveSuccess />,
        },
        {
            path: PATH.HELLO_KLARITY_MAPPING_PAUSE_SUCCESS,
            element: <HelloKlarityMappingPauseSuccess />,
        },
        {
            path: PATH.SALES_PROVIDER_EXP,
            element: <SalesProviderExp />,
        },
        {
            path: PATH.KLARITY_PLAN_PROCESS,
            element: <KlarityPlanProcess />,
        },
        {
            path: PATH.KIWI_KNOWLEDEG,
            element: <KiwiKnowledge />,
        },
        {
            path: PATH.KLARITY_SUBSCRIPTION,
            element: <KlarityPlanSubscribePage />,
        },
        {
            path: PATH.KLARITY_AGREEMENT,
            element: <KlarityAgreementPage />,
        },
        {
            path: PATH.PPA_SERVICE_TEMPLATE,
            element: <PPAServiceTemplateSetting />,
        },
        {
            path: PATH.OPERATION,
            element: <OperationLayout />,
            children: [
                {
                    path: 'testing/provider',
                    element: <ProviderTest />,
                },
            ],
        },
        {
            path: PATH.DASHBOARD,
            element: <Layout />,
            children: [
                {
                    path: 'testing/review',
                    element: <ReviewTest />,
                },
                {
                    path: 'stripe-checkoutid',
                    element: isProductionEnv() || isPrereleaseEnv() ? <NotFoundPage /> : <StripeCheckoutIdPage />,
                },
            ],
        },
        {
            path: PATH.PAYMENT_SETUP,
            element: <PaymentSetup />,
        },
        {
            path: PATH.PAYMENT_SETUP_SUCCESS,
            element: <PaymentSetupSuccess />,
        },
        {
            path: PATH.SERVICE_SETTING,
            element: (
                <FunctionProvider>
                    <ServiceSettingPage />
                </FunctionProvider>
            ),
        },
        {
            path: PATH.MEDICATION_SETTINGS,
            element: <MedicationSettingsPage />,
        },
        {
            path: PATH.MEDICATION_SETTINGS_SUCCESS,
            element: <MedicationSettingsSuccessPage />,
        },
        {
            path: PATH.PRO_LISTING_SETUP,
            element: <ProListingSetup />,
        },
        {
            path: PATH.PRO_LISTING_SUCCESS,
            element: <ProListingSetupSuccess />,
        },
        {
            path: PATH.MEETING,
            element: <MeetingPage />,
        },
        {
            path: '*',
            element: <NotFoundPage />,
        },
    ];
};

// const ROUTERS: RouteObject[] =

export { ROUTERS };
